<template>
  <div>
    <div class="text-center des-css" v-if="status === 'processing'">
      正在登录中...
    </div>
    <div class="text-center des-css" v-if="status === 'success'">登录成功</div>
    <div
      class="text-center des-css"
      v-if="status === 'failed' || status === 'failed403'"
    >
      <div class="input-full-btn" @click="refresh">{{ errorMsg }}</div>
    </div>
  </div>
</template>
<script>
import { loginByOpenPlatform } from '@/core/api'
export default {
  data() {
    return {
      status: 'processing',
      errorMsg: '登录失败，刷新'
    }
  },
  mounted() {
    this.login()
  },
  methods: {
    async login() {
      let code = this.$route.query.code
      // let state = this.$route.query.state

      try {
        this.status = 'processing'
        let response = await loginByOpenPlatform(code)
        console.log(response) // eslint-disable-line no-console
        this.status = 'success'
        // TODO 服务器将返回微信粉丝信息，客户信息，需要在这里进行处理。
        // 向父vue页面发送信息
        window.parent.postMessage(
          {
            cmd: 'login',
            params: {
              success: true,
              data: response.data // response.data.subscriber.open_id
            }
          },
          '*'
        )
        // TODO 关闭登录对话框
      } catch (err) {
        if (err.response && err.response.status === 403) {
          this.status = 'failed403'
          this.errorMsg = `${err.response.data}`
        } else {
          // 显示登录错误，同时显示一个刷新图标，可以点击图标再次显示二维码。
          this.status = 'failed'
          this.errorMsg = '登录失败，刷新'
        }
      }
    },
    refresh() {
      window.parent.postMessage(
        {
          cmd: 'refresh',
          params: {
            success: true
          }
        },
        '*'
      )
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/styles/css_base.scss';
.des-css {
  height: 215px;
  // line-height: 215px;
  padding-top: 80px;
  background-color: $c-white;
  .input-full-btn {
    margin: 0 0;
    display: inline-block;
    width: 70%;
  }
}
</style>
